import {
  createEmailCodeRequestStore,
  extractEmailCodeDomainError,
  isValidEmailAddress,
  isValidEmailCode,
  readAndClearEmailCodeEntry,
  type EmailCodeDomainError,
  type EmailCodeEntry,
  type StoredEmailCodeRequest,
} from '@/features/emailCodeVerification';

const magicAuthStore = createEmailCodeRequestStore('client-magic-auth-request-v1');

export type StoredMagicAuthRequest = StoredEmailCodeRequest;
export type MagicLinkEntry = EmailCodeEntry;
export type MagicAuthDomainError = EmailCodeDomainError;
export const isValidMagicEmail = isValidEmailAddress;
export const isValidMagicCode = isValidEmailCode;
export const saveMagicAuthRequest = magicAuthStore.save;
export const readMagicAuthRequest = magicAuthStore.read;
export const clearMagicAuthRequest = magicAuthStore.clear;
export const readAndClearMagicLinkEntry = readAndClearEmailCodeEntry;
export const getMagicAuthDomainError = extractEmailCodeDomainError;
